import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Save } from '@mui/icons-material'
import { Box, Checkbox, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

const EditGoogleDriveStatusesDialog = ({ onClose, onSave, open, options, statuses }) => {
    const { t } = useTranslation()

    const [enabledStatuses, setEnabledStatuses] = useState(statuses || [])

    const onCheckboxChange = (event) => {
        const { checked, value } = event.target

        if (checked) {
            const statusToEnable = options.find((status) => status.value === value)
            setEnabledStatuses([...enabledStatuses, statusToEnable])
        } else {
            setEnabledStatuses(enabledStatuses.filter((status) => status.value !== value))
        }
    }

    const closeDialog = () => {
        onClose()
    }

    const onSaveDialog = () => {
        onSave(enabledStatuses)
    }

    return (
        <Dialog
            maxWidth="xs"
            open={open}
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 2,

                    width: 300,
                },
            }}
            onClose={closeDialog}
        >
            <DialogTitle
                alignItems="center"
                data-testid="edit-statuses-modal"
                display="flex"
                justifyContent="space-between"
            >
                <Typography variant="strong1">{t('STATUSES')}</Typography>
                <IconButton
                    color="secondary"
                    data-testid="status-save-button"
                    disabled={!enabledStatuses.length}
                    onClick={onSaveDialog}
                >
                    <Save />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body2">
                    {t("Select which status(es) will trigger the sending of the quote's zip file to Google Drive.")}
                </Typography>
                <Box sx={{ mt: 2 }}>
                    {options.map((status) => (
                        <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="row"
                            key={status.value}
                            width="100%"
                        >
                            <Checkbox
                                checked={enabledStatuses.some((s) => s.value === status.value)}
                                color="secondary"
                                data-testid="status-option-checkbox"
                                size="small"
                                value={status.value}
                                onChange={onCheckboxChange}
                            />
                            <Typography data-testid="status-option-label">{status.label}</Typography>
                        </Box>
                    ))}
                </Box>
            </DialogContent>
        </Dialog>
    )
}

EditGoogleDriveStatusesDialog.defaultProps = {
    open: false,
}

EditGoogleDriveStatusesDialog.propTypes = {
    open: PropTypes.bool,
    options: PropTypes.array,
    statuses: PropTypes.array,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
}

export default EditGoogleDriveStatusesDialog
